// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._qtt8glyw{list-style:none}._19bvidpf{padding-left:0}\n._ca0qidpf{padding-top:0}\n._n3tdidpf{padding-bottom:0}\n._u5f3idpf{padding-right:0}", ""]);
// Exports
module.exports = exports;
